<template>
  <div id="main">
  </div>

  <div class="content">
    <div class="header">
      <div style="display: flex; justify-content: right; gap: 10px; padding: 10px;">
        <a href="/" class="start">
          home.
        </a>
      </div>
    </div>

    <div class="sub">
      <img class="logo" src="@/assets/img/adept.svg" alt="Adept Logo" />
      <h1 class="not-found">404 - Not Found</h1>
    </div>

    <div class="footer">
      <div style="display: flex; justify-content: right; gap: 10px; padding: 10px;">
        <span class="text">© adept - all rights reserved.</span>
        <a class="text" href="/wp-content/uploads/2022/11/Privacy-Policy-Adept-1.pdf">privacy policy.</a>
        <a class="text" href="/terms_and_conditions">terms and conditions.</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.text {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 15px;
  font-style: normal;
  color: inherit;
}

#main {
  background-image: url('/question.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  filter: invert(0.1);
}

.content {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  color: #f1f1f1;
  width: 100%;
  height: 100%;
}

.sub {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 30px;
  position: fixed;
  width: 100%;
  background: rgba(255, 255, 255, 0.4);
}

.logo {
  width: 40vh;
}

.header {
  text-align: right;
  //padding: 10px;
  position: fixed;
  width: 100%;
  background: rgba(255, 255, 255, 0.4);
  top: 0;
}

.footer {
  text-align: right;
  //padding: 10px;
  position: fixed;
  width: 100%;
  background: rgba(255, 255, 255, 0.4);
  bottom: 0;
}

.start {
  font-family: "Poppins", sans-serif;
  display: inline-block;
  outline: 0;
  border: none;
  cursor: pointer;
  font-weight: 600;
  border-radius: 8px;
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  background-color: #3c2766;
  color: white;
  padding: 0 20px;
  text-decoration: none;
  user-select: none;
}

.start:hover {
  background-color: #772ce8;
}

.not-found {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 3vh;
  font-style: normal;
  color: inherit;
}

</style>

<script setup>
</script>
